export default {
	APP_CODE: "web_portal",
	APP_CODE_VENDOR: "web_portal_vendor",
	SIDEBAR_TITLE: import.meta.env.VITE_SIDEBAR_TITLE,
	BACKEND_ENDPOINT: import.meta.env.VITE_BACKEND_ENDPOINT,
	CONSIGNMENT_BACKEND_ENDPOINT: import.meta.env
		.VITE_CONSIGNMENT_BACKEND_ENDPOINT,
	// Consignment REST routes on the KrakenD rest-gateway (base path /v1/consignment);
	// file uploads are REST, which the GraphQL gateway does not proxy.
	CONSIGNMENT_REST_ENDPOINT: import.meta.env.VITE_CONSIGNMENT_REST_ENDPOINT,
	BACKEND_FILE_ENDPOINT: import.meta.env.VITE_BACKEND_FILE_ENDPOINT,
	// Public landing (daftar, lacak).
	LANDING_URL: import.meta.env.VITE_LANDING_URL as string | undefined,
	IS_STOCK_IN_FROM_GATEWAY:
		import.meta.env.VITE_STOCK_IN_FROM_GATEWAY === "true",
	ENABLE_TANSTACK_DEVTOOLS:
		import.meta.env.VITE_ENABLE_TANSTACK_DEVTOOLS === "true",
};

// getActiveAppCode returns the APP_CODE that scopes the current session's
// permissions, derived from the current URL path. /vendor/* runs the vendor
// portal app; everything else is the admin web portal. Detection at call
// time means a single bundle serves both apps without separate builds.
export function getActiveAppCode(): string {
	if (typeof window === "undefined") return "web_portal";
	return window.location.pathname.startsWith("/vendor")
		? "web_portal_vendor"
		: "web_portal";
}
